import {
  CostScore,
  SolutionMap,
  SolutionOptionKey,
} from "@labs/shared/types/Solution.ts";
import { FuelSource } from "@labs/shared/types/FuelSource.ts";
import { IntermediateResults } from "@labs/shared/types/AnalyzedPlan.ts";
import { getSolutionValueDecimal } from "./getSolutionValueDecimal.ts";
import { electricConversionFactor } from "../../data/planAnalysisConstants.ts";

export const calculateElectrification = (
  solutionMap: SolutionMap,
  key: SolutionOptionKey,
  unitsOfEnergyAfterIntensityReduction: number,
  conversionFactor: number,
  cop: number,
  fuelSource: FuelSource,
): IntermediateResults => {
  const electrificationDecimal = getSolutionValueDecimal(solutionMap, key);
  const unitsOfCarbonAfterIntensityReduction =
    unitsOfEnergyAfterIntensityReduction * conversionFactor;
  const unitsOfEnergyAfterElectrification =
    unitsOfEnergyAfterIntensityReduction * (1 - electrificationDecimal);
  const electricityImpact =
    (unitsOfEnergyAfterIntensityReduction - unitsOfEnergyAfterElectrification) /
    cop;
  const unitsOfCarbonAfterElectrification =
    unitsOfEnergyAfterElectrification * conversionFactor;
  const electricityImpactCarbon = electricityImpact * electricConversionFactor;
  const carbonImpact =
    unitsOfCarbonAfterElectrification -
    unitsOfCarbonAfterIntensityReduction +
    electricityImpactCarbon;
  const costScore = -carbonImpact * CostScore.Three;

  return {
    unitsOfEnergy: unitsOfEnergyAfterIntensityReduction,
    unitsOfEnergyAfterReduction: unitsOfEnergyAfterIntensityReduction,
    unitsOfCarbonAfterReduction: unitsOfCarbonAfterElectrification,
    carbonImpact,
    costScore,
    solutionPercent: electrificationDecimal * 100,
    fuelImpacts: [
      {
        fuelSource,
        carbonImpact: carbonImpact - electricityImpactCarbon,
      },
      {
        fuelSource: FuelSource.Electricity,
        carbonImpact: electricityImpactCarbon,
      },
    ],
  };
};
